<template>
  <div class="userCenter">
    <job-header-simple header_title="个人中心" :left_arrow="top_left_arrow" :left_text="top_left_text"></job-header-simple>
    <header>
      <div class="radius_cornor">
        <van-uploader
          v-model="userImage"
          :max-count="2"
          :deletable="false"
          :preview-full-image="false"
          :after-read="beforeReadImg"
        />
        <div class="info">
          <p class="name">{{activeUserInfo.name}}</p>
          <p class="tel">{{activeUserInfo.mobile_phone}}</p>
        </div>
      </div>
    </header>
    <van-cell-group>
      <van-cell is-link to="/partner_company_search" class="item">
        <template #title>
          <img src="./assets/icon_user_fuwuqiye.png" />服务企业
        </template>
      </van-cell>
      <van-cell is-link to="/partner_recharge_search" class="item">
        <template #title>
          <img src="./assets/icon_user_qiyechongzi.png" />企业充值
        </template>
      </van-cell>
      <van-cell is-link to="/partner_pay_search" class="item">
        <template #title>
          <img src="./assets/icon_user_fafanjilu.png" />发放记录
        </template>
      </van-cell>
      <van-cell is-link to="/partner_income_index" class="item">
        <template #title>
          <img src="./assets/icon_user_wodeyongjin.png" />我的佣金
        </template>
      </van-cell>
      <van-cell is-link to="/partner_my_achieve" class="item" v-show="userType==3">
        <template #title>
          <img src="./assets/icon_user_tuanduiyeji.png" />团队业绩
        </template>
      </van-cell>
      <van-cell is-link to="/partner_editPassword" class="item">
        <template #title>
          <img src="./assets/icon_user_xiugaimima.png" />修改密码
        </template>
      </van-cell>
    </van-cell-group>

    <van-button type="default" size="large" @click="logout" class="btn_logout">退出登录</van-button>
  </div>
</template>
<script>
import { Image, Cell, CellGroup, Button, NavBar, Uploader } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
const srcheader = require("@/assets/user2.png");
import api from "@/api/list";
import { removePartnerToken } from "@/utils/auth";
import { uploadFile } from "@/api/admin/file";

import { getUserTypeCode, removeUserTypeCode } from "@/utils/auth";

export default {
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Uploader.name]: Uploader,
    jobHeaderSimple
  },
  data() {
    return {
      srcheader: srcheader
        ? srcheader
        : require("../../assets/img_default.png"),
      activeUserInfo: {},
      top_left_arrow: false,
      top_left_text: "",
      userImage: [],
      userType: getUserTypeCode()
    };
  },
  created() {
    this.initActiveUserInfo();
  },
  methods: {
    beforeReadImg() {
      if (this.userImage.length == 2) {
        this.userImage.shift();
      }
      uploadFile(
        "employee-headshot",
        this.base64toFile(this.userImage[0].content)
      ).then(res => {
        if (res.data.status == "200") {
          api
            .partnetSetHeadshot({ url: res.data.data }, { method: "patch" })
            .then(res => {
              if (res.data.status != "200") {
                this.$toast(res.data.message);
              }
            });
        } else {
          this.$toast(res.data.message);
        }
      });
    },
    initActiveUserInfo() {
      api.partnetGetActiveUserPartInfo().then(res => {
        if (res.data.status == "200") {
          this.activeUserInfo = res.data.data[0];
          if (
            res.data.data[0].avatar &&
            typeof res.data.data[0].avatar != "undefined"
          ) {
            this.userImage.push({
              //  url:"http://183.62.139.165:85/upload/content/article/img/201911/79c25e7c-2430-4278-baff-0ba707985f50.png"
              url: process.env.VUE_APP_FILE_PATH + res.data.data[0].avatar
            });
          }
        }
      });
    },
    logout() {
      if (this.$store.getters.browserUA == "MINI") {
        api.MiniLogout({}, { method: "patch" }).then(res => {
          if (res.data.data) {
            this.clearLoginInfo();
          }
        }).catch(()=>{
             this.clearLoginInfo();
            // setTimeout(function() {
            //   location.reload();
            // }, 500);
        })
      } else if (this.$store.getters.browserUA == "WX") {
        api.WxLogout({}, { method: "patch" }).then(res => {
          if (res.data.data) {
            this.clearLoginInfo();
            // setTimeout(function() {
            //   location.reload();
            // }, 500);
          }
        }).catch(()=>{
             this.clearLoginInfo();
            // setTimeout(function() {
            //   location.reload();
            // }, 500);
        })
      } else {
        this.clearLoginInfo();
        setTimeout(function() {
          location.reload();
        }, 500);
      }
    },
    clearLoginInfo() {
      //debugger
      this.$store.dispatch("FedLogOut").then(() => {
        removePartnerToken();
        removeUserTypeCode();
        this.$router.push({ path: "/partner_login" });
      });
    },
    base64toFile(dataurl, filename = "headPportrait") {
      let arr = dataurl.split(",");

      let mime = arr[0].match(/:(.*?);/)[1];

      let suffix = mime.split("/")[1];

      let bstr = atob(arr[1]);

      let n = bstr.length;

      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      });
    }
  }
};
</script>

<style lang="less" scoped>
.userCenter {
  header {
    padding: 10px 12px;
    background: #8390eb;
    background: -webkit-linear-gradient(#8390eb, transparent);
    background: -o-linear-gradient(#8390eb, transparent);
    background: -moz-linear-gradient(#8390eb, transparent);
    background: linear-gradient(#8390eb, transparent);

    /deep/ .van-uploader {
      vertical-align: middle;
      .van-uploader__upload {
        position: relative;
        background: url(../../assets/img_default.png) center center no-repeat
          #ebecf4;
        background-size: 73px 73px;
        border-color: transparent;

        .van-uploader__upload-icon {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 16px;
          height: 17px;
          background: url(../../assets/icon_camera.png) center center no-repeat
            transparent;
          background-size: contain;

          &:before {
            content: "";
          }
        }
      }

      .van-uploader__preview + .van-uploader__upload {
        background: transparent;
        margin-left: -88px;
      }
    }
    .radius_cornor {
      padding: 16px;
      background: url(../../assets/logo_bg.png) right 10px no-repeat #fff;
      background-size: 138px 132px;
      border-radius: 6px;
      .info {
        display: inline-block;
        vertical-align: middle;
        margin-left: 16px;
        color: #333;
        p {
          padding: 0;
          margin: 0;
        }
        .name {
          line-height: 30px;
          font-size: 18px;
        }

        .tel {
          line-height: 26px;
          font-size: 12px;
        }
      }
    }
  }

  .item {
    color: #333;
    // font-size: 14px;
    // line-height: 22px;
    // padding: 12px;
    img {
      display: inline-block;
      vertical-align: top;
      width: 0.64rem;
      height: 0.64rem;
      margin: 0 8px;
    }

    .van-icon-arrow {
      // height: auto;
      // font-size: 20px;
      // margin-top: 6px;
      color: #ddd;
    }
  }

  .btn_logout {
    //     height: 45px;
    //     font-size: 14px;
    margin-top: 15px;
  }
}
</style>


